module.exports = __webpack_public_path__ + "static/media/lidan.fa409ef6.png";